// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const styles = theme => ({
  imageContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  image: {
    display: 'flex',
    marginRight: 15,
    width: 210,
    height: 60,
    cursor: 'pointer',
    [theme.breakpoints.down(500)]: {
      width: 150,
      height: 43,
    },
    [theme.breakpoints.down(350)]: {
      width: 125,
      height: 36,
    },
  },
  smallImage: {
    display: 'flex',
    marginRight: 10,
    cursor: 'pointer',
    width: 150,
    height: 43,
    [theme.breakpoints.down(700)]: {
      width: 125,
      height: 36,
    },
  },
});

export default styles;
